import { ChartCallout } from "./ChartCallout";
import { ChartElement } from "./ChartElement";

export class ChartExtension {
   mainCallout: ChartCallout|null;
   line1: ChartElement|null;
   line2: ChartElement|null;
   leftText1: ChartElement|null;
   rightText1: ChartElement|null;
}
